import React from 'react'
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core'
import BankRow from './BankRow'
import { makeStyles } from '@material-ui/core/styles'
import { colors } from 'constants/index'

const useStyles = makeStyles({
  checked: {
    color: colors.PRIMARY.COLOR[50],
  },
  radioBtn: {
    backgroundColor: 'transparent',
  },
  formControlLabel: {
    marginTop: 16,
    width: '100%',
  },
  label: {
    width: '100%',
  },
})

const ClientBanksRadioButtonList = ({ value, bankAccounts, onChange }) => {
  const classes = useStyles()
  return (
    <RadioGroup value={value || ''} onChange={e => onChange(e.target.value)}>
      {bankAccounts.map(bank => {
        const isReady = bank.status === 'ready'
        return (
          <FormControlLabel
            classes={{ root: classes.formControlLabel, label: classes.label }}
            value={bank.payment_method_id}
            key={bank.payment_method_id}
            disabled={!isReady}
            control={
              <Radio
                checked={value === bank.payment_method_id}
                color="default"
                classes={{ checked: classes.checked, root: classes.radioBtn }}
                disabled={!isReady}
              />
            }
            label={<BankRow bankData={bank} key={bank.payment_method_id} variant="paymentSelection" />}
          />
        )
      })}
    </RadioGroup>
  )
}

export default ClientBanksRadioButtonList
